/**
 * Build upsert objects for linking a user to features.
 */
export function buildFeatureUpsertObjects(
  featureIds: number[],
  userId: number,
  createdBy: string,
) {
  return featureIds.map(featureId => ({
    user_id: userId,
    feature_id: featureId,
    created_by: createdBy,
    updated_by: createdBy,
  }));
}

/**
 * Build upsert object for linking a user to a customer.
 */
export function buildCustomerUpsertObject(
  userId: number,
  customerId: number,
  createdBy: string,
) {
  return {
    user_id: userId,
    customer_id: customerId,
    created_by: createdBy,
    updated_by: createdBy,
  };
}
